import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogData } from '../patient-current-encounters/patient-current-encounters.component';

export class warningDialogModel {
  constructor(public title: string, public message: string) {
  }
}

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.css']
})
export class WarningDialogComponent implements OnInit {

  title: string;
  message: string;

  constructor(public dialogRef: MatDialogRef<WarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: warningDialogModel) {
    this.title = data.title;
    this.message = data.message;
  } 

  ngOnInit() {
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

}
